import {
    Dialog,
    useSetCurrentDocumentTitle,
    useTranslations,
    useUrlParamsValueToString,
} from "@bsm/component";
import { useCallback } from "react";
import { TTimeOff } from "@bsm/graphql";
import { useNavigate, useParams } from "react-router-dom";
import { useTimeOffQuery } from "hooks/useTimeOffQuery";
import { AppointmentDetailsToolbox } from "views/calendar/views/details/components/AppointmentDetailsToolbox";
import { useTimeOffInvalidateQuery } from "hooks/useTimeOffInvalidateQuery";
import { DayoffMissingDetails } from "../components/DayoffMissingDetails";

const DayoffMissingDetailscontainer = () => {

    const [
        DETAILS
    ] = useTranslations(i18n)
    const { id } = useParams()
    const { data } = useTimeOffQuery(parseInt(id), true);
    const invalidateTimeOffQuery = useTimeOffInvalidateQuery()
    useSetCurrentDocumentTitle('TimeOffTitle', data?.title)
    const navigate = useNavigate()
    const urlParamsToString = useUrlParamsValueToString()

    const handleClose = useCallback(() => {
        navigate(`..?${urlParamsToString}`)
    }, [id, urlParamsToString, navigate])

    const handleDeleted = useCallback(() => {
        invalidateTimeOffQuery()
        handleClose()
    }, [invalidateTimeOffQuery, handleClose])

    return (
        <>
            <Dialog
                open={id !== undefined}
                className="max-w-3xl"
                title={data?.title ?? DETAILS}
                onClose={handleClose}>
                <DayoffMissingDetails
                    {...data}
                    toolbox={(
                        <AppointmentDetailsToolbox
                            {...data}
                            onDeleted={handleDeleted}
                        />
                    )}
                />
            </Dialog>
        </>
    );
};

const i18n = [
    'std_details'
]

export default DayoffMissingDetailscontainer;

export type VacationDialogStateProps = {
    id?: number;
    isKanban?: boolean;
    onClose?: () => void;
    onSubmited?: (data?: TTimeOff) => void;
    onDeleted?: (data?: Record<string, any>) => void;
};
